import dayjs from "dayjs";
const timezone = require("dayjs/plugin/timezone");
const utc = require("dayjs/plugin/utc");

dayjs.extend(utc);
dayjs.extend(timezone);

export const getDiffTime = time => {
  const date = new Date(time);
  const now = new Date();
  const diff = now - date;

  const times = [
    {time: "분", milliSeconds: 1000 * 60},
    {time: "시간", milliSeconds: 1000 * 60 * 60},
    {time: "일", milliSeconds: 1000 * 60 * 60 * 24},
    {time: "개월", milliSeconds: 1000 * 60 * 60 * 24 * 30},
    {time: "년", milliSeconds: 1000 * 60 * 60 * 24 * 365},
  ].reverse();

  for (const value of times) {
    const betweenTime = Math.floor(diff / value.milliSeconds);
    if (betweenTime > 0) {
      return `${betweenTime}${value.time} 전`;
    }
  }
  return "방금 전";
};

export const convertDuration = duration => {
  return `${Math.floor(duration / 60)
    .toString()
    .padStart(2, "0")}:${(Math.ceil(duration) % 60).toString().padStart(2, "0")}`;
};

export const convertToKst = date => dayjs(date).tz("Asia/Seoul");

export const handleUploadedTime = createdAt => {
  const today = convertToKst();
  const createdTime = convertToKst(createdAt);
  const diffDay = today.diff(createdAt, "d");
  const diffHour = today.diff(createdAt, "h");
  const diffMin = today.diff(createdAt, "m");
  const diffSec = today.diff(createdAt, "s");

  if (diffDay > 8) return createdTime.format("YYYY.MM.DD");
  if (diffDay > 0 && diffDay < 8) return `${diffDay}days ago`;
  if (diffHour > 0 && diffHour < 24) return `${diffHour}hours ago`;
  if (diffMin > 0 && diffMin < 60) return `${diffMin}min ago`;
  if (diffSec > 0 && diffSec < 60) return `${diffSec}sec ago`;
};

export const getDateLinkedByStr = (paramDate, str) => {
  const targetDate = new Date(paramDate);
  if (!dateIsValid(targetDate)) {
    return;
  }
  const year = targetDate.getFullYear();
  const month = targetDate.getMonth() + 1;
  const date = targetDate.getDate();

  return year + str + `${month < 10 ? `0${month}` : month}` + str + `${date < 10 ? `0${date}` : date}`;
};

function dateIsValid(date) {
  return date instanceof Date && !isNaN(date);
}

export const convertMilliseconds = ms => {
  return {
    milliseconds: Math.floor((ms % 1000) / 10),
    seconds: parseInt((ms / 1000) % 60),
    minutes: parseInt((ms / (1000 * 60)) % 60),
  };
};

export const convertToTimeString = numList => {
  return numList.map(num => `${num < 10 ? 0 : ""}${num}`).join(":");
};

export const getKSTDateString = () => {
  const date = new Date();

  date.setTime(date.getTime() + 9 * 60 * 60 * 1000);

  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = date.getUTCDate().toString().padStart(2, "0");
  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");
  const seconds = date.getUTCSeconds().toString().padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
